<template>
  <div class="e-finish">
    <b-row>
      <b-col cols="12">
        <b-tabs nav-wrapper-class="e-tabs__header" class="e-tabs" nav-class="e-tabs__nav-tabs" content-class="e-tabs__nav-item">
          <b-tab v-for="(criterion, i) in criteria" :title="`${criterionEval(criterion.id).toFixed(1)}  |  ${criterion.title}`" :key="criterion.id">
            <b-row class="e-view-rate">
              <b-col cols="9">
                <div class="eval" @click="onEditClick(i)">
                  {{ criterionEval(criterion.id).toFixed(1) }}
                  <div class="edit"><i class="fas fa-pen"></i></div>
                </div>
                <div class="text">
                  {{ criterionJustification(criterion.id) }}
                </div>
              </b-col>
              <b-col cols="3">
                <em-asset-average-score :score="averageEvaluation.toFixed(1)">Average score of you rating</em-asset-average-score>
              </b-col>
            </b-row>
          </b-tab>
        </b-tabs>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import {mapGetters, mapActions} from 'vuex';
  import EmAssetAverageScore from "../averageScore";
  // Temporarily disabled during legacy build migration.
  // import markdownEditor from 'vue-simplemde/src/markdown-editor'

	export default {
		name: "em-rate-finish",
    components: {EmAssetAverageScore},
    props: {
      criteria: Array,
    },
    methods: {
      onEditClick(num) {
        this.$emit('editCriterion', ++num);
      }
    },
    computed: {
      ...mapGetters('rate', {
        criterionEval: 'getCriterionEvaluation',
        criterionJustification: 'getCriterionJustification',
        averageEvaluation: 'getAverageEvaluation',
      })
    }
	}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/modals/rate/finish.vue